import * as React from 'react';

import { IPublishedConnectionDetailInfo } from '../../ts/models/IPublishedConnectionInfo';
import { PublishedConnectionScheduledTasksView } from './scheduledTasks/PublishedConnectionScheduledTasksView';

export const PublishedConnectionScheduledTasksSubplace: React.FC<{
  publishedConnectionDetailInfo: IPublishedConnectionDetailInfo;
}> = ({ publishedConnectionDetailInfo }) => {

  return (
    <PublishedConnectionScheduledTasksView publishedConnectionDetailInfo={publishedConnectionDetailInfo}/>
  );
};
PublishedConnectionScheduledTasksSubplace.displayName = 'PublishedConnectionScheduledTasksSubplace';
